"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GET_TASK_PROGRESS = void 0;
const gql_1 = require("../../../../../__generated__/gql");
exports.GET_TASK_PROGRESS = (0, gql_1.gql)(`
  query HLQATaskProgress(
    $catalogId: ID!,
    $productTreeId: ID!,
    $filter: PriorityTasksFilter
  ) {
    catalog(id: $catalogId) {
      priorityTasks(productTreeId: $productTreeId, filter: $filter, first: 1) {
        edges {
          node {
            productsReviewed
            taskCount
          }
        }
      }
    }
  }
`);
